<template>
  <div>
    <b-form-group
      label="Ödeme Tanımı"
      label-for="title"
    >
      <validation-provider
        #default="{ errors }"
        name="Ödeme Tanımı"
        rules="required"
      >
        <b-form-input
          id="title"
          v-model="dataItem.title"
          placeholder="Ödeme Tanımı"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'TitleCard',
  components: {
    BFormInput, BFormGroup, ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['paymentCollections/dataItem']
    },
  },
}
</script>
